import { GetServerSideProps } from 'next';

import { About } from '@/features/About';
import { api } from '@/features/About/api';
import { AboutPageData } from '@/features/About/About.types';

import { withNavigationData } from '@/utils/withNavigationData';

type PageProps = {
  config: AboutPageData;
};

const Page = ({ config }: PageProps) => (
  <About aboutData={config} />
);

export const getServerSideProps: GetServerSideProps = withNavigationData(async context => {
  let config;

  try {
    const { data } = await api.getAboutPage(
      { locale: context.locale }
    );

    config = data.data.attributes;
  } catch (error) {
    return {
      redirect: {
        destination: `/${context.locale}/404`,
        permanent: true,
      },
    };
  }

  return {
    props: {
      config,
    },
  };
});
export default Page;
